import { createContext } from 'react';

const petfinderContext = createContext();

export default petfinderContext;
